import React from "react";
import { Modal, Button, Text } from "@nextui-org/react";
import ReactJson from "react-json-view";

export default function ErrorInfo({
  children,
  makeVisible = false,
  setVisible = () => null,
  errInfo,
}) {
  const closeHandler = () => {
    setVisible(false);
    console.log("closed");
  };
  return (
    <div>
      {children}
      <Modal
        closeButton
        blur
        aria-labelledby="modal-title"
        open={makeVisible}
        onClose={closeHandler}
        width="1300px"
        scroll
      >
        <Modal.Header>
          <Text id="modal-title" size={18} b>
            Meta Log
          </Text>
        </Modal.Header>
        <Modal.Body>
          <ReactJson src={errInfo} />
        </Modal.Body>
        <Modal.Footer>
          <Button auto onPress={closeHandler}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
